import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from '@chakra-ui/react';
import { useCreateTeamModal } from './create-team.controller';

interface IProps {
	isOpen: boolean;
	close: () => void;
}

export default function CreateTeamModal(props: IProps) {
	const { form, handleSubmit, t } = useCreateTeamModal(props);

	return (
		<>
			<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
				<ModalOverlay />
				<ModalContent as="form" onSubmit={handleSubmit}>
					<ModalHeader>
						<Heading size="lg">{t('Create a new team')}</Heading>
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box>
							<FormControl id="name">
								<FormLabel>{t('Team name')}</FormLabel>
								<Input type="text" {...form.register('name')}></Input>
							</FormControl>
						</Box>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={props.close}>
							{t('Close')}
						</Button>
						<Button
							isDisabled={!form.formState.isValid}
							isLoading={form.formState.isSubmitting}
							colorScheme="primary"
							type="submit"
						>
							{t('Create')}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
